export enum VettingTabsEnum {
    SUGGESTED = 'SUGGESTED',
    APPLIED = 'APPLIED',
    VETTED = 'VETTED',
    SHORTLIST = 'SHORTLIST',
    FINALIST = 'FINALIST',
    REJECTED = 'REJECTED'
}